const DIRECT_MUTATION_WORDS =
  /\b(?:add|create|make|build|insert|set|connect|change|update|edit|replace|fix|resolve|remove|delete|wire|finish)\b|^(?:please\s+)?complete\b|(?:추가|만들|생성|삽입|설정|연결|변경|수정|교체|고치|해결|삭제|제거|바꾸|완료시|마무리)|(?:追加|作成|生成|挿入|設定|接続|変更|修正|置換|削除|完了させ)|(?:添加|新增|创建|建立|插入|设置|設定|连接|連接|修改|修复|修正|替换|替換|解决|刪除|删除|移除|完成它)/i

const PRESENTATION_MUTATION_WORDS =
  /\b(?:show|display)\b|(?:표시|보여)|(?:表示)|(?:显示|顯示)/i

const UI_PRESENTATION_TARGET =
  /\b(?:new|card|component|element|page|screen|view|panel|section|widget|button|dashboard)\b|(?:새|새로운)\s*(?:카드|컴포넌트|요소|페이지|화면|패널|섹션|위젯|버튼|대시보드)|(?:카드|컴포넌트|요소|페이지|화면|패널|섹션|위젯|버튼|대시보드)(?:를|을|에)|(?:カード|コンポーネント|要素|ページ|画面|パネル|セクション|ウィジェット|ボタン|ダッシュボード)|(?:卡片|组件|元件|页面|頁面|画面|面板|区块|區塊|小组件|小工具|按钮|按鈕|仪表板|儀表板)/i

const EXPLICIT_MUTATION_NEGATION =
  /\b(?:do\s+not|don't|without)\s+(?:add|adding|create|creating|make|making|build|building|insert|inserting|set|setting|connect|connecting|change|changing|modify|modifying|update|updating|edit|editing|replace|replacing|fix|fixing|resolve|resolving|remove|removing|delete|deleting|wire|wiring|finish|finishing|show|showing|display|displaying)\b|(?:아무것도\s*)?(?:추가|생성|삽입|설정|연결|변경|수정|교체|해결|삭제|제거|표시)(?:을|를|도|은|는)?\s*하지\s*(?:마세요|말아줘|말아|말고|않고|마)|(?:만들|고치|바꾸)지\s*(?:마세요|말아줘|말아|말고|않고|마)/i

/**
 * Removes mutation verbs that the user explicitly negated. The remaining
 * text is safe to classify for an actual edit request; the negated clause can
 * still carry the noun that a read-only answer is about.
 */
export function stripNegatedStudioChatMutations(content: string): string {
  return content
    // Past-participle descriptions name the current context; they are not
    // instructions. Other imperative verbs in the sentence remain available
    // to the classifier (for example, "연결된 데이터소스를 수정해줘").
    .replace(
      /(?:추가|생성|삽입|설정|연결|변경|수정|교체|해결|삭제|제거|표시)(?:된|되어|돼)/g,
      '',
    )
    .replace(
      /\b(?:do\s+not|don't|without)\s+(?:add|adding|create|creating|make|making|build|building|insert|inserting|set|setting|connect|connecting|change|changing|modify|modifying|update|updating|edit|editing|replace|replacing|fix|fixing|resolve|resolving|remove|removing|delete|deleting|wire|wiring|finish|finishing|show|showing|display|displaying)\b(?:\s+(?:anything|it|the\s+(?:app|page|screen|selection)))?/gi,
      '',
    )
    .replace(
      /(?:아무것도\s*)?(?:추가|생성|삽입|설정|연결|변경|수정|교체|해결|삭제|제거|표시)(?:을|를|도|은|는)?\s*하지\s*(?:마|말아|말고|마세요|말아줘|않고)/g,
      '',
    )
    .replace(
      /(?:만들|고치|바꾸)지\s*(?:마|말아|말고|마세요|말아줘|않고)/g,
      '',
    )
}

export function hasStudioChatMutationIntent(content: string): boolean {
  const classified = stripNegatedStudioChatMutations(content)
  return (
    DIRECT_MUTATION_WORDS.test(classified) ||
    (PRESENTATION_MUTATION_WORDS.test(classified) &&
      UI_PRESENTATION_TARGET.test(classified))
  )
}

/**
 * True only when the user explicitly forbids a mutation. A prompt can still
 * contain a real bounded edit followed by a guard such as "change the title,
 * but don't change anything else"; callers must also check whether a
 * non-negated mutation remains before suppressing a model-proposed action.
 */
export function hasExplicitStudioChatMutationNegation(
  content: string,
): boolean {
  return EXPLICIT_MUTATION_NEGATION.test(content)
}
